import { colors } from "../../../components/colors";
import { formatMoneyAmount } from "../../../util";
import { parse } from "iso8601-duration";

export const VOUCHER_TYPES = {
  PERCENTAGE_PRODUCT: "DISCOUNT_TYPE_PERCENTAGE_PRODUCT",
  PERCENTAGE_ORDER: "DISCOUNT_TYPE_PERCENTAGE_ORDER",
  VALUE_ORDER: "DISCOUNT_TYPE_VALUE_ORDER",
};

export const discountTypeLabels = new Map([
  [VOUCHER_TYPES.PERCENTAGE_ORDER, "Percentage discount on order"],
  [VOUCHER_TYPES.PERCENTAGE_PRODUCT, "Percentage discount on product"],
  [VOUCHER_TYPES.VALUE_ORDER, "Value discount on order"],
]);

export const discountTypeBadgeBackgroundColors = new Map([
  [VOUCHER_TYPES.PERCENTAGE_ORDER, colors.orangeLight],
  [VOUCHER_TYPES.PERCENTAGE_PRODUCT, colors.ctaLight],
  [VOUCHER_TYPES.VALUE_ORDER, colors.blueLight],
]);

export const discountTypeBadgeTextColors = new Map([
  [VOUCHER_TYPES.PERCENTAGE_ORDER, colors.organgeDark],
  [VOUCHER_TYPES.PERCENTAGE_PRODUCT, colors.ctaMain],
  [VOUCHER_TYPES.VALUE_ORDER, colors.blueDark],
]);

export const discountTypeBadgeBorderColors = new Map([
  [VOUCHER_TYPES.PERCENTAGE_ORDER, colors.orangeMedium],
  [VOUCHER_TYPES.PERCENTAGE_PRODUCT, colors.ctaSecondaryOne],
  [VOUCHER_TYPES.VALUE_ORDER, colors.blueMedium],
]);

export const formatDiscountValue = (
  discountValue: number,
  type: string,
  currency: string
) => {
  if (
    type === VOUCHER_TYPES.PERCENTAGE_ORDER ||
    type === VOUCHER_TYPES.PERCENTAGE_PRODUCT
  ) {
    return `${discountValue}%`;
  }
  const formatted = formatMoneyAmount(discountValue, currency);
  return formatted;
};

export const voucherTypeOptions = [
  {
    label: discountTypeLabels.get(VOUCHER_TYPES.PERCENTAGE_ORDER),
    value: VOUCHER_TYPES.PERCENTAGE_ORDER,
  },
  {
    label: discountTypeLabels.get(VOUCHER_TYPES.PERCENTAGE_PRODUCT),
    value: VOUCHER_TYPES.PERCENTAGE_PRODUCT,
  },
  {
    label: discountTypeLabels.get(VOUCHER_TYPES.VALUE_ORDER),
    value: VOUCHER_TYPES.VALUE_ORDER,
  },
];

const prefixFormattedIso = (shouldPrefix: boolean, isoString: string) => {
  let formattedIso = isoString;
  if (shouldPrefix) {
    formattedIso = `, ${isoString}`;
  }
  return formattedIso;
};

const formatIsoDuration = (num: number, durationUnit: string) => {
  return num > 1 ? `${num} ${durationUnit}s` : `${num} ${durationUnit}`;
};

export function isoToHumanReadable(isoString: string) {
  // Parse ISO 8601 duration
  const parsed = parse(isoString);

  let durationString = "";

  if (parsed.years && parsed.years > 0) {
    durationString += formatIsoDuration(parsed.years, "year");
  }

  if (parsed.months && parsed.months > 0) {
    durationString += prefixFormattedIso(
      durationString.length > 0,
      formatIsoDuration(parsed.months, "month")
    );
  }

  if (parsed.weeks && parsed.weeks > 0) {
    durationString += prefixFormattedIso(
      durationString.length > 0,
      formatIsoDuration(parsed.weeks, "week")
    );
  }

  if (parsed.days && parsed.days > 0) {
    durationString += prefixFormattedIso(
      durationString.length > 0,
      formatIsoDuration(parsed.days, "day")
    );
  }

  if (parsed.hours && parsed.hours > 0) {
    durationString += prefixFormattedIso(
      durationString.length > 0,
      formatIsoDuration(parsed.hours, "hour")
    );
  }

  if (parsed.minutes && parsed.minutes > 0) {
    durationString += prefixFormattedIso(
      durationString.length > 0,
      formatIsoDuration(parsed.minutes, "minute")
    );
  }

  if (parsed.seconds && parsed.seconds > 0) {
    durationString += prefixFormattedIso(
      durationString.length > 0,
      formatIsoDuration(parsed.seconds, "second")
    );
  }

  return durationString;
}
